import { Session } from "../types";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export async function whoami() {
  let resp = await fetch(`${API_URL}`);
  if (!resp.ok) {
    throw new Error(`Request failed with status ${resp.status}`, {
      cause: resp.status,
    });
  }

  let data = await resp.json();
  return data;
}

export async function login(
  username: string,
  password: string,
): Promise<Session> {
  let resp = await fetch(`${API_URL}/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      username: username,
      password: password,
    }),
  });

  if (!resp.ok) {
    throw new Error(`Request failed with status ${resp.status}`, {
      cause: resp.status,
    });
  }

  let data: Session = await resp.json();
  return data;
}

export async function logout(): Promise<{}> {
  let resp = await fetch(`${API_URL}/logout`, {
    method: "POST",
  });

  if (!resp.ok) {
    throw new Error(`Request failed with status ${resp.status}`);
  }

  let data = await resp.json();
  return data;
}
